import gql from 'graphql-tag';

export default gql`
  fragment contentMailFormUrlFragment on ContentMailFormUrl {
    id
    uuid
    url
    isConvertUrl
    createdAt
    updatedAt
  }
`;
